import { useMemberSettings } from "@hooks/useMemberSettings";
import logger from "@utils/logger";
import { useEffect } from "react";

/**
 * Load theme color from local storage
 * Apply theme to:
 * - body className
 * - bg-body background image
 * - meta theme-color
 */
const ThemeColorLoader = () => {
  const { themeId } = useMemberSettings();

  // update theme class to body
  useEffect(() => {
    const themeConfigs = import.meta.env.VITE_THEME_CONFIGS;
    let themeConfig = themeConfigs[themeId];

    // Fallback to purple-stardust if theme ID is unknown
    if (!themeConfig) {
      logger._console.error(
        `ThemeColorLoader: themeConfig not found for themeId "${themeId}", falling back to purple-stardust`,
      );
      themeConfig = themeConfigs["purple-stardust"];
      if (!themeConfig) {
        logger._console.error("ThemeColorLoader: purple-stardust fallback themeConfig not found");
        return;
      }
    }

    const bodyClassList = Array.from(document.body.classList);

    // check if themeColor is same as current theme
    const currentTheme = bodyClassList.find((cls) => cls.startsWith("sdk-theme-"));
    if (currentTheme === themeConfig.className) {
      logger._console.debug("ThemeColorLoader: themeColor is same as current theme, skipping");
      return;
    }

    // remove current theme class with prefix sdk-theme-
    document.body.classList.remove(
      ...Array.from(document.body.classList).filter((cls) => cls.startsWith("sdk-theme-")),
    );

    // update body className
    document.body.classList.add(themeConfig.className);

    // update meta theme-color
    document.querySelector("meta[name='theme-color']")?.setAttribute("content", themeConfig.metaThemeColor);
  }, [themeId]);

  return null;
};

export default ThemeColorLoader;
